/* eslint @okta/okta-ui/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import $ from '../jquery-wrapper';

Handlebars.registerHelper('xsrfTokenInput', function () {
  return new Handlebars.SafeString(
    '<input type="hidden" class="hide" name="_xsrfToken" ' + 'value="' + $('#_xsrfToken').text() + '">'
  );
});

export default Handlebars;
